var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundedRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#522F91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4714 17.4514C12.2052 17.4881 12 17.7197 12 17.9999C12 18.3056 12.2442 18.5535 12.5455 18.5535H22.1333L18.6698 22.0542L18.6169 22.1162C18.458 22.3326 18.475 22.6401 18.6682 22.8371C18.8808 23.0537 19.2261 23.0544 19.4396 22.8387L23.8318 18.3997C23.858 18.3743 23.8816 18.3462 23.9024 18.316C24.0511 18.0998 24.0301 17.7999 23.8396 17.6074L19.4396 13.1613L19.3783 13.1078C19.1644 12.9475 18.8614 12.966 18.6682 13.163C18.4556 13.3796 18.4564 13.7301 18.6698 13.9458L22.1342 17.4464H12.5455L12.4714 17.4514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedRightIcon);
export default __webpack_public_path__ + "static/media/rounded-right-icon.720b0577a7dcec8c8e4318b71e30c3cf.svg";
export { ForwardRef as ReactComponent };